/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I take a points hit to catch a price rise?`)
};

const es_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Debería sacrificar puntos para aprovechar una subida de precio?`)
};

const de_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollte ich Punkte opfern, um einen Preisanstieg mitzunehmen?`)
};

const nl_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moet ik puntenverlies accepteren om een prijsstijging te vangen?`)
};

const fr_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois-je sacrifier des points pour profiter d'une hausse de prix ?`)
};

const it_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conviene sacrificare punti per cogliere un rialzo di prezzo?`)
};

const pt_br2_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vale a pena perder pontos para pegar uma alta de preço?`)
};

const pt_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo perder pontos para apanhar uma subida de preço?`)
};

const ja_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値上がりを狙うためにポイントのペナルティを受けるべきですか？`)
};

const zh_f1_bb_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为了抓住一次涨价，值得承受积分损失吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_bb_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_bb_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_bb_faq3_q", locale)
	if (locale === "en") return en_f1_bb_faq3_q(inputs)
	if (locale === "es") return es_f1_bb_faq3_q(inputs)
	if (locale === "de") return de_f1_bb_faq3_q(inputs)
	if (locale === "nl") return nl_f1_bb_faq3_q(inputs)
	if (locale === "fr") return fr_f1_bb_faq3_q(inputs)
	if (locale === "it") return it_f1_bb_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_bb_faq3_q(inputs)
	if (locale === "pt") return pt_f1_bb_faq3_q(inputs)
	if (locale === "ja") return ja_f1_bb_faq3_q(inputs)
	return zh_f1_bb_faq3_q(inputs)
};